export default __webpack_public_path__ + "af45c80a20b7b9243aee6fa78185560d.jpg";